import { IMoneySourceProps } from '../../types';
import { EMoneySource } from '../../../../types/reducers/user';
import { RadioButton } from '@cian/ui-kit';
import { getOptionDataName } from './utils';
import * as React from 'react';

export const MoneySourceButton = ({
  disabled,
  onChange,
  active,
  value,
  label,
}: IMoneySourceProps & { onChange: (value: EMoneySource) => void }) => {
  const handleChange = () => {
    if (!disabled) {
      onChange(value);
    }
  };

  return (
    <RadioButton
      key={value}
      value={value}
      name={value}
      label={label}
      disabled={disabled}
      checked={active}
      data-checked={active}
      data-test={value}
      data-name={getOptionDataName(value)}
      onChange={handleChange}
    />
  );
};
